import RootStore from './RootStore';
import { IResult } from '../global';
import galleryApi, { IOneMediaItem } from '../actions/gallery';
import { qrcodePayDialog } from '../utils/dom';
import { observable, action } from 'mobx';

interface IPagedataCurrentGallerys {
  [key: string]: any;
}

interface ICurrentLoading {
  [key: string]: boolean;
}

export default class PagedataStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }
  @observable parentLinkId = ''; // 当前页面的父级元素的link_id
  @action setParentLinkId(link_id: string) {
    this.parentLinkId = link_id;
  }

  parentPageData = null as any;
  parentPageDataPromise = null as any;

  @observable currentGallerys = {} as IPagedataCurrentGallerys;
  // 汇总页头图单独读取主相册浏览量，不放进 currentGallerys，避免改变照片数量累加。
  @observable mainGalleryViews = {} as { [id: string]: number };
  mainGalleryViewsRequests = {} as { [id: string]: Promise<number> | undefined };
  @observable renderMode = "mobile";

  currentLoadingGallerys = {} as ICurrentLoading;

  formatGallery(it: any) {
    // 修改当前状态
  }

  @action setRenderMode(mode: string) {
    this.renderMode = mode;
  }

  @action updateGalleryCount(galleryid: string, count: number) {
    this.currentGallerys = {
      ...this.currentGallerys,
      [String(galleryid)]: {
        ...this.currentGallerys[String(galleryid)],
        image_total: count
      }
    };
  }

  getGallerys(ids: string[]) {
    let empty: any[] = [];
    let extra: any[] = [];

    ids.forEach(id => {
      if (
        !this.currentGallerys[id] &&
        !Boolean(this.currentLoadingGallerys[id + ''])
      ) {
        if (empty.length < 50) {
          empty.push(id);
          this.currentLoadingGallerys[id + ''] = true;
        } else {
          extra.push(id);
        }
      }
    });
    if (empty.length) {
      return galleryApi.batch(empty).then(
        action((res: any) => {
          // 如果还有需要请求的，再来请求一次
          if (extra && extra.length) {
            this.getGallerys(extra);
          }

          let { data } = res;
          data.forEach(
            action((it: any) => {
              this.currentGallerys = {
                ...this.currentGallerys,
                [String(it.id)]: it
              };

              if (it.watermarks) {
                this.rootStore.galleryStore.setWatermarksByKey(it.id, it.watermarks);
              }
              // this.currentGallerys[String(it.id)] = it;
            })
          );
        })
      );
    } else {
      return new Promise(resolve => resolve(true));
    }
  }

  @action setGallery = (id: string | number, it: any) => {
    this.currentGallerys = {
      ...this.currentGallerys,
      [String(id)]: it
    };
  }

  checkPermission(linkid: string) {
    return galleryApi.checkPermission(linkid);
  }

  doPermission(data: any) {
    return galleryApi.doPermission(data);
  }

  sendValidate(phone: string, country: string = '86') {
    return galleryApi.sendValidate(phone, country);
  }

  validateCodeV2(phone: string, country: string = '86', code: string) {
    return galleryApi.validateCodeV2(phone, country, code);
  }

  validatePhoneV2(linkid: string, whitelist: number, action: string) {
    return galleryApi.validatePhoneV2(linkid, whitelist, action);
  }

  validatePostPaperV2(
    linkid: string,
    parentLinkId: string | undefined,
    action: string,
    rawData: any
  ) {
    return galleryApi.validatePostPaperV2(
      linkid,
      parentLinkId,
      action,
      rawData
    );
  }

  validatePassV2(linkid: string) {
    return galleryApi.validatePassV2(linkid);
  }

  getViewDetail(video: boolean = false, videov2: boolean = false) {
    let currentGallerys = this.currentGallerys;
    let showIds = [];
    let imagecount = 0;
    let imageviews = 0;

    if (window.dataDetail) {
      let data = currentGallerys[window.dataDetail.id];
      if (data) {
        imagecount = data.image_total * 1;
        imageviews = data.view_detail ? data.view_detail.view * 1 : 0;

        // 如果是子相册的模式下，需要去掉一些内容
        // let {uncheckList, hideList} = this.rootStore.galleryStore;
        // imagecount -= uncheckList.length + hideList.length;
      }
    } else {
      Object.keys(currentGallerys).forEach((key: string) => {
        let data = currentGallerys[key];
        imagecount += data.image_total * 1;
        imageviews += data.view_detail ? data.view_detail.view * 1 : 0;
      });
    }

    if (video) {
      let { galleryStore } = this.rootStore;
      let { mediaList, getMediaList } = galleryStore;
      if (typeof mediaList.data != 'undefined') {
        (mediaList.data.items || []).forEach((item: IOneMediaItem) => {
          imageviews += item.view * 1;
        });
      } else {
        galleryStore.getMediaList(window.gallery.id + '');
      }
    }

    if (videov2) {
      let { videoStore } = this.rootStore;
      let videoViews = videoStore.views;
      if (videoViews) {
        imageviews += videoViews;
      }
    }

    return {
      imagecount,
      imageviews
    };
  }

  loadMainGalleryViews(id: string): Promise<number> {
    if (Object.prototype.hasOwnProperty.call(this.mainGalleryViews, id)) {
      return Promise.resolve(this.mainGalleryViews[id]);
    }
    const pending = this.mainGalleryViewsRequests[id];
    if (pending) return pending;

    const request = galleryApi.batch([id]).then(action((response: any) => {
      const gallery = (response.data || []).find((item: any) => String(item.id) === id);
      if (!gallery) throw new Error('主相册统计数据缺失');
      const views = Number(gallery.view_detail && gallery.view_detail.view);
      const value = Number.isFinite(views) && views >= 0 ? views : 0;
      this.mainGalleryViews = { ...this.mainGalleryViews, [id]: value };
      return value;
    })).then(value => {
      delete this.mainGalleryViewsRequests[id];
      return value;
    }, error => {
      delete this.mainGalleryViewsRequests[id];
      throw error;
    });
    this.mainGalleryViewsRequests[id] = request;
    return request;
  }

  getParentPgData(linkid: string) {
    if (this.parentPageData) {
      return new Promise((resolve) => {
        resolve(this.parentPageData);
      });
    }
    if (this.parentPageDataPromise) {
      return this.parentPageDataPromise;
    }
    let promise = galleryApi.getParentPgData(linkid).then(jsonData => {
      const { data, success, code } = jsonData;
      if (success || code === 200) {
        //const { template } = data;
        this.parentPageData = data;

        return data;
      }
      console.error('数据异常', jsonData);
      return null;
    });

    this.parentPageDataPromise = promise;
    return promise;
  }

  getCustomForm(linkid: string) {
    return galleryApi.getCustomForm(linkid).then(jsonData => {
      const { data, success, code } = jsonData;
      if (success || code === 200) {
        return data;
      }
      return null;
    });
  }

  getPayGood(goods_id: string | number) {
    return galleryApi.getPayGood(window.gallery.id, goods_id).then(jsonData => {
      return jsonData.data;
    });
  }

  makePrePay(goods_id: string | number, link_id: string, usePay: boolean) {
    return galleryApi
      .makePrePay(window.gallery.id, link_id, goods_id)
      .then(jsonData => {
        if (
          jsonData &&
          jsonData.code == 200 &&
          jsonData.data &&
          jsonData.data.id
        ) {
          if (usePay) {
            if (typeof window.pingpp == 'object') {
              return this.doPay(jsonData.data);
            }
          }
        }
        return jsonData;
      });
  }

  doPay = (data: any, options?: any) => {
    return new Promise<any>((resolve, reject) => {
      if (typeof window.pingpp == 'object') {
        if (data.channel == 'wx_pub_qr') {
          let credential = data.credential[data.channel];
          if (credential) {
            qrcodePayDialog(credential, resolve, options);
          }
        } else {
          window.pingpp.createPayment(data, (result: any, err: any) => {
            resolve(result);
          });
        }
      } else {
        reject();
      }
    });
  };

  makePayUseCharge(
    goods_id: string | number,
    link_id: string,
    charge_id: string | number,
    usePay: boolean
  ) {
    return galleryApi
      .makePayUseCharge(window.gallery.id, charge_id)
      .then(jsonData => {
        if (
          jsonData &&
          jsonData.code == 200 &&
          jsonData.data &&
          jsonData.data.id
        ) {
          if (usePay) {
            return this.doPay(jsonData.data);
          }
        } else {
          return this.makePrePay(goods_id, link_id, usePay);
        }

        return jsonData;
      });
  }

  getCharge(goods_id: string | number) {
    return galleryApi.checkPayResult(window.gallery.id, goods_id);
  }

  getCurrentGallerys = () => {
    return Object.keys(this.currentLoadingGallerys);
  };
}
